module.exports = __webpack_public_path__ + "static/media/20.16b60b29.jpg";